import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import strings from 'common/Translation/Translate';
import { useSelector } from 'react-redux';
import SearchBar from 'screens/Authenticated/SearchBar';
import { searchedData } from 'utils/redux/reducer/searched-data-slice';
import OrganisationListCard from './OrganisationListCard';

const AvailableOrganisations = () => {
  const data = useSelector(searchedData);

  return (
    <>
      <SearchBar />
      {data?.length > 0 ? (
        <Box>
          <OrganisationListCard data={data} />
        </Box>
      ) : (
        <Box>
          <Typography>{strings.no_venue_Found_error_message}</Typography>
        </Box>
      )}
    </>
  );
};
export default AvailableOrganisations;
